import React, { useState } from "react";
import { ActionPanel } from "components/panel";
import { Button } from "components/buttons";
import { LicenceCheckingService } from "services/LicenceCheckingService";
import { NotificationToaster } from "components/notifications";
import { Intent } from "@blueprintjs/core";
import PropTypes from "prop-types";

export function InvalidInsurancePanel({ checkData, reloadCheck }) {
    const [isSaving, setIsSaving] = useState(false);

    function handleInvalidInsurance() {
        setIsSaving(true);

        LicenceCheckingService.resendInsuranceDetailsReminder(checkData?.id)
            .then(
                () => {
                    NotificationToaster.show(
                        Intent.SUCCESS,
                        "Insurance details reminder email resent successfully."
                    );
                    reloadCheck();
                },
                (err) => {
                    const validationError = 400;
    
                    if (err?.response?.status === validationError && err.response.data != null) {
                        NotificationToaster.show(
                            Intent.WARNING,
                            err.response.data
                        );
                        return;
                    }

                    NotificationToaster.show(
                        Intent.DANGER,
                        "Unable to resend insurance details reminder email. Please try again later."
                    );
                }
            )
            .catch(() => {
                NotificationToaster.show(
                    Intent.DANGER,
                    "Unable to resend insurance details reminder email. Please try again later."
                );
            })
            .finally(() => {
                setIsSaving(false);
            });
    }

    return (
        <div className="spacer-top">
            <ActionPanel intent="warning" title="Invalid Insurance">
                <p className="spacer-bottom">
                    The Insurance documents provided have been reviewed and are
                    not valid. To restart the process so that new documents can
                    be uploaded please click the button below.
                </p>
                <Button
                    id="invalid-insurance-resend-email"
                    onClick={handleInvalidInsurance}
                    text={"Restart Insurance Request"}
                    icon="reset"
                    intent="Primary"
                    disabled={isSaving}
                />
            </ActionPanel>
        </div>
    );
}

InvalidInsurancePanel.propTypes = {
    checkData: PropTypes.object.isRequired,
    reloadCheck: PropTypes.func.isRequired,
};
